export default __webpack_public_path__ + "static/media/4.b3b5518a.jpg";